<template lang="pug">
  div.atu.objects-update
    e-form-modal(
    ref="modalForm"
    @submitModalForm="onSubmitModalForm()"
    :hideDeleteButton="false"
    :saveBtnLabel="locationTariffIsActive ? 'Рассчитать' : 'Сохранить'"
    :savingBtnLabel="locationTariffIsActive ? 'Расcчет...' : 'Сохранение...'"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
        v-model="tabView"
        :tabs="tabs"
        )
      slot
        e-form(:formValidator="formValidator" scrollUpdateStreamName="atu.objectUpdate.scroll")
          // вкладка ОБЩИЕ СВЕДЕНИЯ
          div(v-if="tabView === 'tab1'")
            div.body
              div.col
                e-form-group(
                name="name"
                inputType="input"
                label="Наименование"
                :model="fields"
                :required="true"
                tabView="tab1"
                )
                e-form-group(
                name="type_id"
                label="Тип"
                inputType="select"
                :options="geoObjectTypes"
                :model="fields"
                :required="true"
                tabView="tab1"
                )
                e-form-group(
                  name="availability_id"
                  label="Признак доступности"
                  inputType="select"
                  :options="availability"
                  :model="fields"
                  :required="false"
                  tabView="tab1"
                )
                template(
                v-if="parentItem && parentItems"
                )
                  e-form-group(
                  v-if="parentItemsList.length > 0"
                  name="parent_id"
                  label="Находится в составе"
                  :model="fields"
                  tabView="tab1"
                  inputType="select"
                  :options="parentItemsList"
                  )
                e-form-group(
                name="okato"
                inputType="input"
                validationRule="number"
                label="ОКАТО"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="oktmo"
                inputType="input"
                validationRule="number"
                label="OKTMO"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="area"
                inputType="input"
                validationRule="double"
                label="Площадь, га"
                :model="fields"
                tabView="tab1"
                )
                div.col-block.scroll-block(
                v-if="tkoOperators.length > 0"
                )
                  label Региональные операторы:
                  p(
                  v-for="operator in tkoOperators"
                  :key="operator.id"
                  )
                    router-link(
                    :to="{path: `/regoperators/update/${operator.id}`}"
                    ) {{operator.name}}
                div.col-block(
                v-else-if="fields.tkoOperator && fields.tkoOperator.name"
                )
                  label Региональный оператор:
                  p
                    router-link(
                    :to="{path: `/regoperators/update/${fields.tkoOperator.id}`}"
                    ) {{fields.tkoOperator.name}}
                div.col-block(
                v-else
                )
                  label Региональный оператор:
                  p не назначен
              div.col
                e-form-subtitle(text="Численность населения, чел.")

                e-form-group(
                name="year"
                inputType="select"
                :options="years"
                label="Год"
                :model="currentResidentYear"
                @change="setCurrentResidents()"
                tabView="tab1"
                )
                e-form-group(
                name="apartment_building_residence"
                inputType="input"
                label="Численность в МКД, чел"
                :model="currentResidents"
                tabView="tab1"
                validationRule="number"
                :onChangeValidation="true"
                )
                e-form-group(
                name="private_house_residence"
                inputType="input"
                label="Численность в ИЖД, чел"
                :model="currentResidents"
                tabView="tab1"
                validationRule="number"
                :onChangeValidation="true"
                )
                e-form-group(
                name="total_residents"
                inputType="input"
                label="Итого:"
                :model="currentResidents"
                tabView="tab1"
                )

              div.col
                div.col-block

                e-form-group(
                name="detail"
                inputType="textarea"
                label="Контактные данные"
                :model="fields"
                tabView="tab1"
                )
                e-form-group(
                name="link"
                inputType="url"
                label="Сайт"
                :model="fields"
                tabView="tab1"
                )


          // вкладка НАСЕЛЕННЫЕ ПУНКТЫ
          div(v-if="tabView === 'tab2'")
            div.body.body-table
              div.table-choose-panel
                div.toolbar-table
                  div.select.list Населенные пункты

                e-table-inner(
                v-if="fields.id"
                tableWrapperClass="table"
                class="table--half"
                :visibleColumns="localityVisibleColumns"
                :itemsEndpoint="endpointLocalityList"
                @deleteItem="deleteLocality($event)"
                :enableInnerPagination="false"
                :showRemoveConfirmation="false"
                ref="localityTable"
                :showDeleteButton="false"
                )

          div(v-if="tabView === 'garbage'")
            garbage-threads-table(
            :id="fields.id"
            )

          div(v-if="tabView === 'location-tariff'")
            div.location-tariff
              div.top-block
                e-form(
                :formValidator="formValidator"
                formClass=" "
                :enablePerfectScrollbar="false"
                )
                  div.body
                    div.col
                      e-form-subtitle(text="Настройки")
                      e-form-group(
                      name="capacity"
                      label="S - средняя производительность принятого в расчетах транспортного средства по вывозу"
                      :model="fields"
                      tabView="location-tariff"
                      validationRule="double"
                      )

                      e-form-group(
                      name="tkoObjectName"
                      realName="tko_object_id"
                      inputType="suggestion"
                      label="Объект размещения"
                      :suggestionEndpoint="suggestionEndpoint"
                      :transformSuggestions="transformSuggestions"
                      @selectItem="selectItem"
                      :suggestDelay="0"
                      :minSuggestLen="2"
                      :useInnerSearch="false"
                      :required="true"
                      :model="fields"
                      tabView="location-tariff"
                      )

                      e-form-group(
                      name="zero_run"
                      label="L0 - средний нулевой пробег, приходящегося на 1 рейс"
                      :model="fields"
                      tabView="location-tariff"
                      validationRule="double"
                      )

                      e-form-group(
                      name="loading_time"
                      label="Н погр-разгр - нормативная продолжительность погрузки-разгрузки, включая маневрирование, час"
                      :model="fields"
                      tabView="location-tariff"
                      validationRule="double"
                      )

                      e-form-group(
                      name="fuel_price"
                      label="Ц - планируемая среднерыночная цена за единицу топлива"
                      :model="fields"
                      tabView="location-tariff"
                      validationRule="double"
                      )

                      e-form-group(
                      name="transport_price"
                      label="Стр - среднерыночная цена транспорта"
                      :model="fields"
                      tabView="location-tariff"
                      validationRule="double"
                      )

                      e-form-group(
                      name="transport_work"
                      label="Гч - годовое число часов работы транспортного средства "
                      :model="fields"
                      tabView="location-tariff"
                      validationRule="double"
                      )

                      e-form-group(
                      name="amortization_rate"
                      label="Н - норма амиортизационных отчислений %"
                      :model="fields"
                      tabView="location-tariff"
                      validationRule="double"
                      )

                      e-form-group(
                      name="fuel_consumption"
                      label="Q - норма расхода топлива"
                      :model="fields"
                      tabView="location-tariff"
                      )

                    div.col
                      e-form-subtitle(text="Параметры для расчета тарифа")
                      e-form-group(
                      v-if="fields.type_id === villageSettlementType"
                      name="geo_object"
                      label="Сельское поселение"
                      :model="fields"
                      tabView="location-tariff"
                      )
                      e-form-group(
                      v-else-if="isLocality()"
                      name="geo_object"
                      label="Населенный пункт"
                      :model="fields"
                      tabView="location-tariff"
                      )
                      e-form-group(
                      v-else-if="isMunicipal()"
                      name="geo_object"
                      label="Муниципальное образование"
                      :model="fields"
                      tabView="location-tariff"
                      )

                      e-form-group(
                      name="population"
                      label="Население"
                      :model="fields"
                      tabView="location-tariff"
                      )

                      e-form-group(
                      name="area"
                      label="Площадь"
                      :model="fields"
                      tabView="location-tariff"
                      )


                      e-form-group(
                      name="containers_count"
                      label="Общее количество контейнерных площадок"
                      :model="fields"
                      tabView="location-tariff"
                      )

                      e-form-group(
                      name="container_volume"
                      label="Средний объём контейнерной площадки"
                      :model="fields"
                      tabView="location-tariff"
                      :required="true"
                      validationRule="double"
                      )

                      e-form-group(
                      name="transport_distance"
                      label="Среднее расстояние транспортировки ТБО"
                      :model="fields"
                      tabView="location-tariff"
                      :required="true"
                      validationRule="double"
                      )

                      e-form-group(
                      name="msn_distance"
                      label="Среднее расстояние между местами сбора"
                      :model="fields"
                      tabView="location-tariff"
                      :required="true"
                      validationRule="double"
                      )


                      e-form-group(
                      name="formed"
                      label="Количество образуемых отходов куб.м./год"
                      :model="fields"
                      tabView="location-tariff"
                      )

                      e-form-group(
                      name="tariff_burial"
                      label="Тариф на захоронение"
                      :model="fields"
                      tabView="location-tariff"
                      :required="true"
                      validationRule="double"
                      )

                      e-form-group(
                      name="tariff_processing"
                      label="Тариф на обработку"
                      :model="fields"
                      tabView="location-tariff"
                      :required="true"
                      validationRule="double"
                      )


                  div.body
                    div.col
                      e-form-subtitle(text="Итоги расчета")
                      e-form-group(
                      name="L_tr"
                      label="L тр"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )
                      e-form-group(
                      name="L_ost"
                      label="L ост метры"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )
                      e-form-group(
                      name="M"
                      label="М ост метры"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )
                      e-form-group(
                      name="N_sred"
                      label="N сред"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )
                      e-form-group(
                      name="O"
                      label="O"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )
                      e-form-group(
                      name="L_sb"
                      label="L сб км"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )

                    div.col
                      e-form-subtitle(text="").is-hidden
                      e-form-group(
                      name="N_e"
                      label="Не"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )
                      e-form-group(
                      name="S_zp"
                      label="C зп"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )
                      e-form-group(
                      name="S_otch"
                      label="Сотч"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )
                      e-form-group(
                      name="S_va"
                      label="Сva"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )
                      e-form-group(
                      name="Q"
                      label="Q"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )

                    div.col
                      e-form-subtitle(text="").is-hidden
                      e-form-group(
                      name="S_t"
                      label="С т"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )
                      e-form-group(
                      name="S_m"
                      label="C м"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )
                      e-form-group(
                      name="S_r"
                      label="C р"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )
                      e-form-group(
                      name="S_oer"
                      label="С оэр"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )
                      e-form-group(
                      name="S_pr"
                      label="С пр"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )
                      e-form-group(
                      name="transport_tariff"
                      label="Тариф на транспортировку 1 куб м тко"
                      :model="fields"
                      tabView="location-tariff"
                      :disabled="true"
                      )

</template>

<script>
  import {atu, tko, core, calculation} from '@/api/api-endpoints'
  import objectForm                    from '../mixins/object-form.js'
  import GarbageThreadsTable from "./components/garbage-threads-table";
  import FormValidator from '../../../components/form/form-validator'

  const TARIFF_ID = 'tariff_id'

  const locationTariff = 'location-tariff'

  export default {
    components: {GarbageThreadsTable},
    mixins: [objectForm],
    data () {
      this.localityTypes = [
        10,11,12,13,15,16,17,18,19,20,21,21
      ]
      this.municipalTypes = [
        1,2,3,4,14
      ]
      this.villageSettlementType = 5
      return {
        tabView: 'tab1',
        fields: {
          availability_id: '',
          _garbageYear: '',
          tko_object_id: '',
          type_id: ''
        },
        errors: null
      }
    },
    computed: {
      tkoOperators() {
        if(this.fields.tkoOperators){
          return this.fields.tkoOperators
        }
        return []
      },
      locationTariffIsActive () {
        return this.tabView === locationTariff
      },
      tabs () {
        const tabs = [
          {tab1: 'Общие сведения'}
        ]

        if (this.fields.id) {
          tabs.push({tab2: 'Населенные пункты'})
          tabs.push({'location-tariff': 'Расчет тарифа'})
          tabs.push({garbage: 'Отходы'})
        }

        return tabs
      }
    },
    created () {
      this.formValidator = new FormValidator(this)
      this.subs = this.$emitter.listen('calc', this.calc)
      this.fetchTariff()
    },
    destroyed () {
      this.subs && this.subs.unsubscribe()
    },
    methods: {
      isLocality(){
        return this.localityTypes.indexOf(this.fields.type_id) > -1
      },
      isMunicipal(){
        return this.municipalTypes.indexOf(this.fields.type_id) > -1
      },
      onSubmitModalForm () {
        if (this.locationTariffIsActive) {
          this.freezeForm()
          this.$emitter.emit('calc', {
            unFreezeFrom: () => this.unFreezeFrom()
          })
        } else {
          this.sendForm()
        }
      },
      getRegionalOperatorEndpoint () {
        return tko.regionalOperators({query: {'per-page': -1}})
      },
      getRegOpEndpoint (id) {
        return tko.operator(id)
      },
      getUpdateOrCreateUrl () {
        return atu.atuObjectUpdateOrCreate(this.$route.params.id)
      },
      getItemEndpoint (route) {
        if (!route.params.id) {
          return null
        }
        return atu.atuObject(route.params.id)
      },
      getCollectionEndpoint () {
        return core.collection('geo_object_type,availability')
      },
      getEndpoint (route) {
        return atu.atuObjects(route)
      },
      suggestionEndpoint (ctx, q) {
        return tko.objects({query: {q, 'per-page': 50}})
      },
      transformSuggestions (ctx, data) {
        return data.data
      },
      async calc ({unFreezeFrom = () => ''} = {}) {
        let {hasError} = this.formValidator.validate(this)
        if(hasError){
          this.$e.errorBox('Проверьте все обязательные поля!')
          unFreezeFrom()
          return
        }
        try {
          if(!this.fields.tariff_id){
            let {data} = await this.$store.dispatch('createModel', {
              url: calculation.locationTariff(),
              data: this.fields
            })
            this.fields.tariff_id = data.id
          }
          let {data} = await this.$store.dispatch('updateModel', {
            url: calculation.locationTariffOneAtuUpdate(this.fields.tariff_id),
            data: this.fields
          })
          this.mapTariffToFields(data)

          this.$e.successBox('Рассчет завершен')
          this.$emit('calcSuccess')

        } catch (erResponse) {
          let {notFoundedErrorFieldsText} = this.formValidator.handleServerErrors(erResponse, this)
          if (notFoundedErrorFieldsText) {
            this.$e.errorBox(
              'Некорректно заполнены поля',
              {text: notFoundedErrorFieldsText}
            )
          }
        }
        unFreezeFrom()
      },
      async fetchTariff () {
        try {
          this.$bar.start()

          if (this.fields.tariff_id) {
            const {data} = await this.$store.dispatch('updateUrlEndpoint', {
              endpoint: calculation.locationTariffOneAtu(this.fields.tariff_id),
              params: {
                disableGlobalError: true
              }
            })

            this.mapTariffToFields(data)
          }
        } catch (e) {
          console.error(e)
          this.$e.errorBox('Ошибка при загрузке тарифа')
        } finally {
          this.$bar.finish()
        }
      },
      mapTariffToFields (data) {
        let id = this.fields.id ? this.fields.id : 0
        let tariff_id = data.id
        this.$set(this.fields, Object.assign(this.fields, data))
        if(!this.fields.tariff_id){
          this.fields.tariff_id = tariff_id
        }
        if(id){
          this.fields.id = id
        }
      }
    }
  }
</script>
